export const blockIconsHomeAirwaveNew = (
	<span className='material-symbols-outlined'>airwave</span>
);
